<template>
  <div style="min-height: 100vh">
    <membership-banner
      :styles="$store.getters['membership'].style"
      :label="$store.getters['membership'].label"
      back_button="/portals"
    ></membership-banner>

    <v-container
      fluid
      elevation-5
      class="white py-0"
      id="portal-settings"
      style="position: fixed; bottom: 0px; left: 0px; right: 0px; z-index: 300"
      v-if="!loading && !selected_applicant"
    >
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <v-btn
            fab
            :small="$vuetify.breakpoint.name === 'xs' ? true : false"
            class="mx-1"
            color="green"
            :dark="modified"
            :disabled="!modified"
            :loading="saving"
            @click="save"
          >
            <v-icon :small="$vuetify.breakpoint.name === 'xs' ? true : false"
              >fa-save</v-icon
            >
          </v-btn>
          <v-btn
            fab
            :outlined="show_sharing ? true : false"
            :small="$vuetify.breakpoint.name === 'xs' ? true : false"
            :dark="saving ? false : true"
            color="#9054ff"
            class="mx-1"
            @click="showSharing"
            :disabled="saving"
          >
            <v-icon :small="$vuetify.breakpoint.name === 'xs' ? true : false"
              >fa-share</v-icon
            >
          </v-btn>

          <v-btn
            :small="$vuetify.breakpoint.name === 'xs' ? true : false"
            fab
            :outlined="show_settings ? true : false"
            color="black"
            class="mx-1"
            title="Edit Portal"
            @click="showSettings"
            :disabled="saving"
          >
            <v-icon
              :color="show_settings ? 'black' : 'white'"
              :small="$vuetify.breakpoint.name === 'xs' ? true : false"
              >fa-cog</v-icon
            >
          </v-btn>
          <!--
          <v-btn
            fab
            color="red"
            :small="$vuetify.breakpoint.name==='xs' ? true : false"
            outlined
            title="Edit Portal"
            class="mx-1"
          >
            <v-icon color="black" :small="$vuetify.breakpoint.name==='xs' ? true : false">fa-film</v-icon>
          </v-btn>
          !-->
        </v-col>
      </v-row>
    </v-container>

    <v-overlay absolute :opacity="0.75" v-if="loading">
      <div class="text-center">
        <v-progress-circular :size="100" indeterminate></v-progress-circular>
        <div class="caption mt-4">Loading</div>
      </div>
    </v-overlay>
    <v-overlay absolute :opacity="0.75" v-if="deleting_applicant">
      <div class="text-center">
        <v-progress-circular :size="100" indeterminate></v-progress-circular>
        <div class="caption mt-4">Deleting Applicant</div>
      </div>
    </v-overlay>
    <v-overlay absolute :opacity="0.75" v-if="uploading_logo">
      <div class="text-center">
        <v-progress-circular :size="100" indeterminate></v-progress-circular>
        <div class="caption mt-4">Uploading Logo</div>
      </div>
    </v-overlay>

    <v-container v-if="item.id">
      <v-row justify="center">
        <v-col cols="11" sm="10" md="9" lg="8" xl="6">
          <v-container class="pa-0" id="portal-logo">
            <v-row justify="center" style="position: relative">
              <v-col
                cols="12"
                sm="11"
                md="10"
                lg="9"
                xl="7"
                class="text-center"
              >
                <div class="clicky">
                  <img
                    :title="item.settings.logo.name"
                    :src="item.settings.logo.url"
                    style="width: 100%; max-width: 375px; height: auto"
                    @click="selectFile"
                  />
                </div>
              </v-col>
              <v-col cols="12" v-if="item.settings.video">
                <div class="d-flex justify-end">
                  <v-btn icon @click="removeVideo">
                    <v-icon>fa-times</v-icon>
                  </v-btn>
                </div>
                <video
                  playsinline
                  style="
                    width: 100%;
                    height: auto;
                    max-height: 66vh;
                    margin-bottom: -8px;
                  "
                  :src="item.settings.video.url"
                  :poster="item.settings.video.thumbnail"
                  controls
                ></video>
              </v-col>
              <v-col
                cols="12"
                sm="11"
                md="10"
                lg="9"
                xl="7"
                class="text-center"
                v-else
              >
                <v-btn
                  @click="selectVideo"
                  color="blue"
                  outlined
                  dark
                  :loading="uploading_video"
                >
                  <v-icon small class="mr-2">fa-plus</v-icon>Video
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

          <v-container class="pa-0" id="portal-info">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  @change="onChange"
                  label="Portal Title (public)"
                  outlined
                  hide-details
                  placeholder="My Portal"
                  dense
                  v-model="item.title"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  dense
                  @change="onChange"
                  :rows="3"
                  label="Portal Description (public)"
                  placeholder="This portal is for..."
                  outlined
                  hide-details
                  v-model="item.description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>

          <portal-applicants
            :edit="true"
            :items="applicants"
            v-model="selected_applicant"
          ></portal-applicants>

          <div id="portal-sections" v-if="!selected_applicant">
            <draggable
              tag="div"
              class="row wrap justify-center align-center"
              @update="onChange"
              handle=".draggable"
              v-model="item.sections"
              @start="drag = true"
              @end="drag = false"
            >
              <template v-for="(section, s) in item.sections">
                <v-col cols="12" :key="`portal-edit-section-${s}`">
                  <portal-section
                    :value="section"
                    @input="updateSection(section, $event)"
                    @remove="removeSection(section)"
                    @bannerColor="onBannerColor"
                    @buttonColor="onButtonColor"
                  ></portal-section>
                </v-col>
              </template>
            </draggable>
            <div id="add-section" class="mt-4">
              <v-row justify="center">
                <v-btn dark fab color="blue" @click="addSection">
                  <v-icon>fa-plus</v-icon>
                </v-btn>
              </v-row>
            </div>
          </div>

          <div id="portal-applicant" v-if="selected_applicant">
            <v-row>
              <v-col cols="12" class="py-0">
                <applicant-info
                  :value="selected_applicant"
                  @change="updateApplicant(selected_applicant)"
                  @delete="deleteApplicant(selected_applicant)"
                ></applicant-info>
              </v-col>
            </v-row>
            <v-row>
              <template v-for="(section, s) in selected_applicant.sections">
                <v-col cols="12" :key="s">
                  <applicant-section
                    :applicant="selected_applicant"
                    :portal="item"
                    :downloads="true"
                    :value="section"
                    @change="updateApplicant(selected_applicant)"
                  ></applicant-section>
                </v-col>
              </template>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-bottom-sheet
      v-model="show_settings"
      inset
      :max-width="700"
      style="z-index: 99"
    >
      <v-sheet class="white" style="padding-bottom: 80px">
        <portal-settings
          @logo-upload="selectFile"
          v-model="item"
          :styles="$store.getters['membership'].style"
          @change="onChange"
        ></portal-settings>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="show_sharing" inset :max-width="500">
      <v-sheet style="padding-bottom: 80px">
        <portal-sharing
          @save="save"
          v-model="item"
          :styles="$store.getters['membership'].style"
          @change="onChange"
        ></portal-sharing>
      </v-sheet>
    </v-bottom-sheet>

    <input
      type="file"
      style="display: none"
      ref="filepicker"
      @change="handleFileChange($event)"
      accept="image/*"
    />
    <input
      type="file"
      style="display: none"
      ref="videoselect"
      @change="handleVideoFile($event)"
      accept="video/mp4, video/quicktime"
    />
  </div>
</template>

<script>
import membershipBanner from "@/components/user/membership_banner";
import portalSettings from "@/components/portal/edit/settings";
import portalSharing from "@/components/portal/edit/sharing";

import portalApplicants from "@/components/portal/applicants";
import applicantInfo from "@/components/portal/applicant-view/info";
import applicantSection from "@/components/portal/applicant-view/section";
import portalSection from "@/components/portal/edit/section";

import draggable from "vuedraggable";

export default {
  name: "UserPortal",
  components: {
    draggable,
    membershipBanner,
    portalSettings,
    portalSharing,
    portalApplicants,
    portalSection,
    applicantSection,
    applicantInfo,
  },
  data() {
    return {
      loading: false,
      uploading_video: false,
      uploading_logo: false,
      saving: false,
      deleting_applicant: false,
      show_settings: false,
      show_sharing: false,
      item: {},
      applicants: [],
      selected_applicant: null,
      modified: false,
      refresh_timer: null,
    };
  },
  computed: {},
  created() {
    this.load();
    //this.refresh_timer = setInterval(this.autoRefresh, 15000);
  },
  beforeDestroy() {
    clearInterval(this.refresh_timer);
  },
  async beforeRouteLeave(to, from, next) {
    if (
      this.modified &&
      !confirm("Do you really want to leave? you have unsaved changes!")
    ) {
      return;
    } else {
      next();
    }
  },
  methods: {
    removeVideo() {
      if (!confirm("Remove video?")) {
        return;
      }
      this.item.settings.video = null;
      this.onChange();
    },
    autoRefresh() {
      if (!document.hidden) {
        this.loadApplicants();
      }
    },
    async deleteApplicant(applicant) {
      this.deleting_applicant = true;
      try {
        await this.$api.delete(
          `/user/portals/${this.item.id}/applicants/${applicant.id}`
        );
        await this.loadApplicants();
        this.selected_applicant = null;
      } catch (ex) {
        console.log("error", ex);
        alert(ex.error);
      }
      this.deleting_applicant = false;
    },
    async updateApplicant(applicant) {
      try {
        await this.$api.patch(
          `/user/portals/${this.item.id}/applicants/${applicant.id}`,
          {
            notes: applicant.notes,
            sections: applicant.sections,
          }
        );
      } catch (ex) {
        alert(ex.error);
        this.load();
      }
    },
    updateSection(section, ev) {
      section = ev;
      this.onChange();
    },
    addSection() {
      let new_section = JSON.parse(
        JSON.stringify(this.$store.state.website.default_portal.sections[0])
      );
      new_section.title = `Section ${this.item.sections.length + 1}`;
      new_section.banner_color = this.item.settings.banner_color;
      new_section.button_color = this.item.settings.button_color;
      this.item.sections.push(new_section);
      this.onChange();
      setTimeout(this.scrollToNewest, 100);
    },
    scrollToNewest() {
      let sections = document.querySelectorAll(".portal-section");
      this.$vuetify.goTo(sections[sections.length - 1]);
    },
    removeSection(section) {
      if (!confirm("Sure you want to delete this section ?")) {
        return;
      }
      this.item.sections.splice(this.item.sections.indexOf(section), 1);
      this.onChange();
    },
    onBannerColor(to) {
      if (this.item.sections.length === 1) {
        this.item.settings.banner_color = to;
        this.onChange();
      }
    },
    onButtonColor(to) {
      if (this.item.sections.length === 1) {
        this.item.settings.button_color = to;
        this.onChange();
      }
    },
    selectFile() {
      this.$refs.filepicker.click();
    },
    handleFileChange(ev) {
      console.log("handleFileChange", ev);
      let file;
      if (ev.target.files) {
        file = ev.target.files[0];
      }
      this.$refs.filepicker.value = null;
      this.uploadLogo(file);
    },
    async uploadLogo(file) {
      this.uploading_logo = true;
      try {
        let form = new FormData();
        form.append("file", file);
        let upload = await this.$api.put(
          `/user/portals/${this.item.id}/upload-logo`,
          form
        );
        this.item.settings.logo = upload;
        this.onChange();
      } catch (ex) {
        alert(ex.error);
      }
      this.uploading_logo = false;
    },
    selectVideo() {
      this.$refs.videoselect.click();
    },
    handleVideoFile(ev) {
      console.log("handleFileChange", ev);
      let file;
      if (ev.target.files) {
        file = ev.target.files[0];
      }
      this.$refs.videoselect.value = null;
      this.uploadVideo(file);
    },
    async uploadVideo(file) {
      this.uploading_video = true;
      try {
        let form = new FormData();
        form.append("file", file);
        let upload = await this.$api.put(
          `/user/portals/${this.item.id}/upload-video`,
          form
        );
        this.item.settings.video = upload;
        this.onChange();
      } catch (ex) {
        alert(ex.error);
      }
      this.uploading_video = false;
    },
    showSettings() {
      if (this.show_settings) {
        this.show_settings = false;
        this.show_sharing = false;
      } else {
        this.show_settings = true;
        this.show_sharing = false;
      }
    },
    showSharing() {
      if (this.show_sharing) {
        this.show_settings = false;
        this.show_sharing = false;
      } else {
        this.show_settings = false;
        this.show_sharing = true;
      }
    },
    onChange() {
      this.modified = true;
    },
    async load() {
      this.loading = true;
      try {
        this.item = await this.$api(`/user/portals/${this.$route.params.id}`);
        this.loadApplicants();
        this.selected_applicant = null;
      } catch (ex) {
        this.$router.push("/portals");
        alert(ex.error);
      }
      this.loading = false;
    },
    async loadApplicants() {
      try {
        let response = await this.$api(
          `/user/portals/${this.$route.params.id}/applicants`
        );
        this.applicants = response;
        this.applicants.forEach(
          function (a) {
            if (this.$helpers.isProcessing(a)) {
              setTimeout(this.loadApplicants, 3000);
            }
          }.bind(this)
        );
      } catch (ex) {
        alert(ex.error);
      }
    },
    async save() {
      this.saving = true;
      try {
        await this.$api.patch(
          `/user/portals/${this.$route.params.id}`,
          this.item
        );
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
        this.load();
      }
      this.saving = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#portal-applicants {
  overflow-y: auto;
  overflow-x: hidden;
  $box-height: 36px;
  @media only screen and (max-width: 600px) {
    /* xs */
    max-height: $box-height * 3;
  }
  @media only screen and (max-width: 960px) and (min-width: 600px) {
    /* sm */
    max-height: $box-height * 3;
  }
  @media only screen and (max-width: 1264px) and (min-width: 960px) {
    /* md */
    max-height: $box-height * 3;
  }
  @media only screen and (max-width: 1904px) and (min-width: 1264px) {
    /* lg */
    max-height: $box-height * 3;
  }
  @media only screen and (min-width: 1904px) {
    /* xl */
    max-height: $box-height * 3;
  }
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>